var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContactContext } from "@/contexts/contact/hooks";
import { useI18n } from "@/shared/hooks";
import { getFeaturesEnabled } from "@/utils/getFeaturesEnabled";
import { Box } from "@gemini/core";
import { TextArea } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { CreateNote } from "./CreateNote";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const MessageInput = ({ contactFormDatas, control, }) => {
    const { t } = useI18n();
    const { messageRequired } = getFeaturesEnabled();
    const { contactCard, subjectLabel } = contactFormDatas;
    const { defaultMessage } = useContactContext();
    const isPreviewMode = useIsPreviewMode();
    return (_jsxs(_Fragment, { children: [_jsx(Controller, { name: "message", control: control, defaultValue: defaultMessage, render: (_a) => {
                    var _b = _a.field, { value } = _b, otherFields = __rest(_b, ["value"]), { fieldState: { error } } = _a;
                    return (_jsx(TextArea, Object.assign({ value: value }, otherFields, { label: subjectLabel, isOptional: !(messageRequired && contactCard.isPrivateOwner), hasNecessityIndicator: false, 
                        //maxCharacters={2500}
                        error: error === null || error === void 0 ? void 0 : error.message, isFullWidth: true, rows: 5, isDisabled: isPreviewMode })));
                } }), _jsxs(Box, { borderColor: "color.border.active.default", borderStyle: "solid", backgroundColor: "color.surface.active.default", paddingLeft: "spacing.16", paddingRight: "spacing.16", paddingBottom: "spacing.8", paddingTop: "spacing.24", borderRadius: "radius.8", marginTop: "-spacing.32", gap: "spacing.12", alignItems: "center", display: "flex", justifyContent: "space-between", children: [_jsx(Box, { children: _jsx(CreateNote, {}) }), _jsxs(Box, { flexGrow: "1", typography: {
                            "breakpoint.base": "typography.body.14.regular",
                            "breakpoint.md": "typography.body.14.regular",
                        }, children: [_jsxs("strong", { children: [t("contact.form.message_hint_0"), " "] }), t("contact.form.message_hint_1")] })] })] }));
};
